
addEventListener();
document.addEventListener('cart:change', async () => {
  await updatedLineItem();
});
document.addEventListener('cart:click', async () => {
  await updatedLineItem();
});

function addEventListener() {
  const sizeSelector = document.querySelectorAll('.v-size-selector');
  sizeSelector.forEach(function(item) {
    item.addEventListener('change', sizeChange);
  });
  const qtySelector = document.querySelectorAll('.v-qty-selector');
  qtySelector.forEach(function(item) {
    item.addEventListener('change', qtyChange);
  });
}

async function sizeChange(event) {
  const element = this.closest(".cartitemkey");
  const dataUpdateElements = this.closest(".update-data-js");
  const lineItemID = element.getAttribute('data-lineitemid');
  const selectedOption = event.target.options[event.target.selectedIndex];
  const id = selectedOption.dataset.id;
  let availableQty = selectedOption.dataset.qty;
  let qty = selectedOption.dataset.qty;
  const cartItemQtySel = document.getElementById("qty-" + lineItemID);
  const cartItemQty = cartItemQtySel.value;
  qty = Math.min(qty, 20); 
  if (parseInt(qty) >= parseInt(cartItemQty)) {
    let optionsHTML = '';
    for (let i = 1; i <= qty; i++) {
      var selectedData = i == cartItemQty ? 'selected' : '';
      optionsHTML += `<option value="${i}" ${selectedData}>${i}</option>`;
    }
    cartItemQtySel.innerHTML = optionsHTML;
    await updateCartSize(dataUpdateElements, lineItemID, id, cartItemQty,availableQty);
  } else {
    // console.log('Qty is not available then set max');
    cartItemQtySel.value = qty; 
    await updateCartSize(dataUpdateElements, lineItemID, id, qty ,availableQty);
  }
}


async function qtyChange(event) {
  const element = this.closest(".cartitemkey");
  const lineItemID = element.getAttribute('data-lineitemid');
  const lineID = element.getAttribute('data-lineid');
  const selectedOption = event.target.options[event.target.selectedIndex];
  const qty = this.value;
  const dataUpdateElements = this.closest(".update-data-js");
  await updateCartQty(dataUpdateElements, lineItemID, qty ,lineID);
}

function disableInputs(dataUpdateElements) {
  dataUpdateElements.querySelector('.v-qty-selector').setAttribute('disabled', true);
  dataUpdateElements.querySelector('.v-size-selector')?.setAttribute('disabled', true);  
  document.querySelector('button[name="checkout"]').setAttribute('disabled', true);
}

function enableInputs(dataUpdateElements) {
  dataUpdateElements.querySelector('.v-qty-selector').removeAttribute('disabled');
  dataUpdateElements.querySelector('.v-size-selector')?.removeAttribute('disabled');
  document.querySelector('button[name="checkout"]').removeAttribute('disabled');
}

function updateUI(dataUpdateElements, addedLineItem) {
  dataUpdateElements.querySelector('.onChangeCartVariant').textContent = addedLineItem.variant_title;
  dataUpdateElements.querySelector('.removeItem-drawer').href = '/cart/change?id=' + addedLineItem.key + '&quantity=0';  
  dataUpdateElements.querySelector('.cartitemkey').setAttribute('data-lineitemid', addedLineItem.key);
  dataUpdateElements.querySelector('.v-qty-selector').setAttribute('id','qty-' + addedLineItem.key);
  dataUpdateElements.querySelector('.v-size-selector')?.setAttribute('id','size-' + addedLineItem.key);
}
function removeDuplicateCartDrawers() {
  try {
    const allCartDrawers = document.querySelectorAll('cart-drawer');
    for (let i = 0; i < allCartDrawers.length - 1; i++) {
      allCartDrawers[i].remove();
    }
  } catch (error) {
    console.error('Error while removing duplicate cart-drawer elements:', error);
  }
}
document.addEventListener('click', function() {
    removeDuplicateCartDrawers();
});
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
async function updatedLineItem() {
  try {
    const response = await fetch('/?section_id=cart-drawer');
    if (!response.ok) {
      throw new Error(response);
    }
    const html = await response.text();
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    const specificElement = tempElement.querySelector('.cart-drawer__items')?.innerHTML;
    const cartTotalItems = tempElement.querySelector('#cart-total-item')?.innerHTML;
    const targetLineItem = document.querySelector('.cart-drawer__items');
    if (targetLineItem){
      targetLineItem.innerHTML = specificElement;
      document.querySelector('#cart-total-item').innerHTML = cartTotalItems;
      console.log('lineItem updated from function');
      fetch('/cart')
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text,"text/html");
        if(document.querySelector('klarna-placement') && html.querySelector('#cart-total-item')) {
          let totalPrice = html.querySelector('#cart-total-item').dataset.totoalPrice
          document.querySelector('free-shipping-bar').innerHTML = html.querySelector('free-shipping-bar').innerHTML
          document.querySelector('klarna-placement').dataset.purchaseAmount = totalPrice
          document.querySelector('.cart-klarna-message').innerHTML =  html.querySelector('.cart-klarna-message').innerHTML
        }
        if(document.querySelector('.cart-clearpay-widget') && html.querySelector('#cart-total-item')) {
          document.querySelector('free-shipping-bar').innerHTML = html.querySelector('free-shipping-bar').innerHTML
          document.querySelector('.cart-clearpay-content').innerHTML =  html.querySelector('.cart-clearpay-content').innerHTML
        }
        
      })
    }
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  } finally {
    addEventListener();
  }
}

async function makeRequest(url, bodyData) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' 
      },
      body: JSON.stringify(bodyData)
    });
    return response;
  } catch (error) {
    console.error('Error during making request: ', error);
    throw error;
  }
}

async function updateCartSize(dataUpdateElements, lineItemkey, id, qty ,availableQty) {
  try {
    disableInputs(dataUpdateElements);

    // Fetch variant details to get available stock
    const variantResponse = await fetch(`/variants/${id}.js`);
    if (!variantResponse.ok) {
      throw new Error('Failed to fetch variant details');
    }
    const variantDetails = await variantResponse.json();
    const maxStock = variantDetails?.inventory_quantity || 0;
    let currentAvailable =  availableQty - qty ;
    // Remove old line item
    const changeResponse = await makeRequest('/cart/change.js', {
      id: lineItemkey,
      quantity: 0
    });
    if (!changeResponse.ok) {
      throw new Error('Failed to remove old line item');
    }

    // Adjust quantity if it exceeds available stock or remove line item if already at maximum
    if (qty > currentAvailable) {
      console.error('Selected quantity exceeds available stock');
    } else {
      // Add new line item with selected quantity
      const addResponse = await makeRequest('/cart/add.js', {
        id: parseInt(id),
        quantity: qty
      });
      if (!addResponse.ok) {
        throw new Error('Failed to add new line item');
      }

      const addedLineItem = await addResponse.json();
      updateUI(dataUpdateElements, addedLineItem);
      await updatedLineItem();
    }
  } catch (err) {
    console.error('Error:', err);
  } finally {
    enableInputs(dataUpdateElements);
  }
}



async function updateCartQty(dataUpdateElements, lineItemkey, qty ,lineID) {
  try {
    disableInputs(dataUpdateElements);
    const changeResponse = await makeRequest('/cart/change.js', {
      id: lineItemkey,
      quantity: qty
    });
    if (!changeResponse.ok) {  
      throw new Error(changeResponse);
    }
    const data = await changeResponse.json();
    await updatedLineItem();
  } catch (err) {
    console.error('Error:', err);
  } finally {
    enableInputs(dataUpdateElements);
  }
}


document.addEventListener('DOMContentLoaded', ()=>{
  let search_inputs = document.querySelectorAll('.search-country-input')
  search_inputs.forEach( input => {
  const countryWrapper = input.closest('.country-select-wrap')
  const countryItems = countryWrapper.querySelectorAll('button')
  input.addEventListener('keyup', ()=>{
    let inputText = input.value.toLowerCase()
    countryItems.forEach(element => {
      let buttonText = element.querySelector('span').textContent || element.querySelector('span').innerText
      buttonText = buttonText.toLowerCase()
        if(buttonText.indexOf(inputText) != -1) {
          element.style.display = "flex"
        }else {
          element.style.display = "none"
        }
      });
    })
  })
});

// for infinite scroll on PDP slider
document.addEventListener('DOMContentLoaded', function() {
  const nextButton = document.querySelector('.next-button');
  const carouselNav = document.querySelector('carousel-navigation');
  if (!nextButton || !carouselNav) return; // not a PDP gallery (was throwing on every other page)
  const buttons = carouselNav.querySelectorAll('button.tap-area');

  nextButton?.addEventListener('click', function() {
    let currentIndex = -1;

    buttons.forEach((button, index) => {
      if (button.getAttribute('aria-current') === 'true') {
        currentIndex = index;
      }
    });

    let nextIndex = currentIndex + 1;

    if (nextIndex >= buttons.length || buttons[nextIndex].hasAttribute('hidden')) {
      let isLastVisibleButton = true;

      for (let i = currentIndex + 1; i < buttons.length; i++) {
        if (!buttons[i].hasAttribute('hidden')) {
          isLastVisibleButton = false;
          break;
        }
      }

      if (isLastVisibleButton) {
        nextIndex = 0;
        while (buttons[nextIndex].hasAttribute('hidden') && nextIndex < buttons.length) {
          nextIndex++;
        }
      }
    }

    if (currentIndex >= 0 && currentIndex < buttons.length) {
      buttons[currentIndex].setAttribute('aria-current', 'false');
    }
    if (nextIndex < buttons.length) {
      buttons[nextIndex].setAttribute('aria-current', 'true');
      buttons[nextIndex].click();
    }
  });
});

// This script was originally Jquery, updated in LYRA81
document.addEventListener('DOMContentLoaded', function () {
  function quick_shift() {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(function (card) {
      const productFigure = card.querySelector('.product-card__figure');
      const quickBuyBtn = card.querySelector('.custom_quickbuy_main');
      if (window.innerWidth < 700) {
        const customQuickBuy = document.querySelector('.custom_quickbuy');
        if (customQuickBuy) {
          customQuickBuy.style.display = 'none'; // Hide custom quick buy
        }
        // The figure itself carries .custom_quickbuy_main, so querySelector can return it;
        // appending it into itself threw on the first card and stopped the loop.
        if (quickBuyBtn && quickBuyBtn !== productFigure && !quickBuyBtn.contains(productFigure)) {
          productFigure.appendChild(quickBuyBtn); // Move quick buy button to product figure
          productFigure.classList.add('custom_quickbuy_main'); // Ensure the class is added
          productFigure.style.display = 'block'; // Show the product figure
        }
      }
    });
  }

  quick_shift(); // Initial call
  window.addEventListener('resize', quick_shift); // Resize event listener
});

// LYRA109: Custom element for sale filter links that replaces rather than adds filters
class SaleFacetLink extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this.onFacetUpdate.bind(this));
  }

  onFacetUpdate(event) {
    event.preventDefault();
    
    const currentUrl = new URL(window.location.href);
    const newUrl = new URL(this.href);
    
    // Create final URL starting from current URL
    const finalUrl = new URL(currentUrl);
    
    // If this is the "All Sale" option, just remove all sale filters
    if (this.getAttribute('data-sale-filter') === 'all') {
      finalUrl.searchParams.delete('filter.p.m.custom.sale');
    } else {
      // Get all sale filter values from the new URL and take the last one (the new one being added)
      const filterValues = newUrl.searchParams.getAll('filter.p.m.custom.sale');
      const filterValue = filterValues[filterValues.length - 1];
      
      // Remove any existing sale filters
      finalUrl.searchParams.delete('filter.p.m.custom.sale');
      
      // If this is not an active filter, add it (meaning we're adding a new filter)
      if (!this.classList.contains('active') && filterValue) {
        finalUrl.searchParams.set('filter.p.m.custom.sale', filterValue);
      }
    }
    
    // Preserve the section_id
    const sectionId = document.querySelector('[section-id]')?.getAttribute('section-id') || 
                     document.querySelector('[data-section-id]')?.getAttribute('data-section-id');
    if (sectionId) {
      finalUrl.searchParams.set("section_id", sectionId);
    }

    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: { url: finalUrl }
    }));
  }
}

if (!window.customElements.get("sale-facet-link")) {
  window.customElements.define("sale-facet-link", SaleFacetLink, { extends: "a" });
}




/* Size wizard replaces legacy .size-chat-trigger → Kiwi modal wiring (see assets/size-wizard.js) */